import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { AuthProvider } from "./context/AuthContext";
import RootLayout from './components/Layouts/RootLayout';
import ProtectedRoute from './components/ProtectedRoute';

import HomePage from './pages/Homepage/page';

import StudentLoginPage from './pages/LoginPage/student/page';
import AdminLoginPage from './pages/LoginPage/admin/page';
import RegisterPage from './pages/RegisterPage/page';

import TableroPage from './pages/student/TableroPage/page';
import ModulesPage from './pages/student/ModulesPage/page';
import GradesPage from './pages/student/GradesPage/page';
import PaymentsPage from './pages/student/PaymentsPage/page';
import NotificationsPage from './pages/student/NotificationsPage/page';
import PayedPage from './pages/student/PaymentsPage/PayedPage/page';
import ModuleDetails from './pages/student/ModulesPage/ModuleDetails/page';
import Evaluation from './pages/student/ModulesPage/Evaluation/page';

import ColaboratorsPage from './pages/admin/ColaboratorsPage/page';
import StudentsPage from './pages/admin/StudentsPage/page';
import AdminPaymentsPage from './pages/admin/PaymentsPage/page';
import AdminModulesPage from './pages/admin/ModulesPage/page';
import ModuleDetailPage from './pages/admin/ModulesPage/ModuleDetails/page';
import StudentDetailsPage from './pages/admin/StudentsPage/StudentDetails/page';
import ColaboratorDetailsPage from './pages/admin/ColaboratorsPage/ColaboratorDetails/page';
import PaymentDetailsPage from './pages/admin/PaymentsPage/PaymentDetails/page';

const App: React.FC = () =>  {
  return (
    <AuthProvider>
      <Router>
        <RootLayout>
          <Routes>
            {/* Común */}
            <Route path='/' element={<HomePage />} />
            <Route path='/studentlogin' element={<StudentLoginPage />} />
            <Route path='/adminlogin' element={<AdminLoginPage />} />
            <Route path='/register' element={<RegisterPage />} />

            {/* Estudiante */}
            <Route path='/student/tablero' element={<ProtectedRoute><TableroPage /></ProtectedRoute>} />
            <Route path='/student/modules' element={<ProtectedRoute><ModulesPage /></ProtectedRoute>} />
            <Route path='/student/grades' element={<ProtectedRoute><GradesPage /></ProtectedRoute>} />
            <Route path='/student/payments' element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
            <Route path='/student/notifications' element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
            <Route path='/payed' element={<ProtectedRoute><PayedPage /></ProtectedRoute>} />
            <Route path='/students/:studentId/modules/:moduleId' element={<ProtectedRoute><ModuleDetails /></ProtectedRoute>} />
            <Route path='/students/:studentId/modules/:moduleId/evaluation' element={<ProtectedRoute><Evaluation /></ProtectedRoute>} />

            {/* Administrador */}
            <Route path='/admin/students' element={<ProtectedRoute><StudentsPage /></ProtectedRoute>} />
            <Route path='/admin/modules' element={<ProtectedRoute><AdminModulesPage /></ProtectedRoute>} />
            <Route path='/admin/payments' element={<ProtectedRoute><AdminPaymentsPage /></ProtectedRoute>} />
            <Route path='/admin/colaborators' element={<ProtectedRoute><ColaboratorsPage /></ProtectedRoute>} />
            <Route path='/admin/modules/:id' element={<ProtectedRoute><ModuleDetailPage /></ProtectedRoute>} />
            <Route path='/admin/students/:id' element={<ProtectedRoute><StudentDetailsPage /></ProtectedRoute>} />
            <Route path='/admin/colaborators/:id' element={<ProtectedRoute><ColaboratorDetailsPage /></ProtectedRoute>} />
            <Route path='/admin/payments/:id' element={<ProtectedRoute><PaymentDetailsPage /></ProtectedRoute>} />
          </Routes>
        </RootLayout>
      </Router>
    </AuthProvider>
  );
}

export default App;
